import { client } from '~/api/client';
import { mutateData, queryData } from '~/api/data/request';
import {
  CreateHtmlDocumentTemplateFromStarterDocument,
  CreateHtmlDocumentTemplateFromStarterMutation,
  CreateHtmlDocumentTemplateFromStarterMutationVariables,
  GetHtmlDocumentTemplateStartersDocument,
  GetHtmlDocumentTemplateStartersQuery,
  GetHtmlDocumentTemplateStartersQueryVariables
} from '~/api/graphql';

export type HtmlDocumentTemplateStarter =
  GetHtmlDocumentTemplateStartersQuery['htmlDocumentTemplateStarters'][number];

export const getHtmlDocumentTemplateStarters = () =>
  queryData<
    GetHtmlDocumentTemplateStartersQuery,
    GetHtmlDocumentTemplateStartersQueryVariables,
    HtmlDocumentTemplateStarter[]
  >(
    client,
    { query: GetHtmlDocumentTemplateStartersDocument },
    (data) => data?.htmlDocumentTemplateStarters || []
  );

export const createHtmlDocumentTemplateFromStarter = (starterId: string) =>
  mutateData<
    CreateHtmlDocumentTemplateFromStarterMutation,
    CreateHtmlDocumentTemplateFromStarterMutationVariables
  >(client, {
    mutation: CreateHtmlDocumentTemplateFromStarterDocument,
    variables: { input: { starterId } }
  });
